// import X from 'scripts/modules/X';
import VenoBox from 'venobox';
import Scrollbar from 'smooth-scrollbar';
import { init as initCarousel } from './modules/Slider';
import { init as initPdpPackages } from './modules/PackagesPdp';
import { init as initPdp } from './modules/Pdp';
import { init as initNav } from './modules/Nav';
import { init as initShopPay } from './modules/ShopPay';

new VenoBox({
  selector: '.zoom-link',
  infinigall: true,
  spinner: 'circle',
  overlayColor: 'rgba(0,0,0,0.7)',
});


document.addEventListener('DOMContentLoaded', () => {
  initNav();
  initCarousel();
  initPdpPackages();
  initShopPay();
  initPdp();
  if (window.innerWidth < 768 && document.querySelector('.mobile-scrollbar')) {
    Scrollbar.init(document.querySelector('.mobile-scrollbar'), {
      alwaysShowTracks: true
    });
  }
});
